export default "__VITE_ASSET__CzvgdCN0__"